import { Alert, Button } from "@nabble/ui";

/** Sign-in with a passkey: one button that hands over to the browser. */
export function PasskeyVerifyPanel({ loading, error, onVerify }: { loading: boolean; error: string | null; onVerify: () => void }): React.JSX.Element {
  return (
    <div className="nb-auth-form">
      <p className="nb-muted">Use Face ID, Touch ID, Windows Hello or your security key, depending on how you registered it.</p>
      {error ? <Alert tone="danger">{error}</Alert> : null}
      <Button label="Use passkey" icon="key" size="lg" block loading={loading} onClick={onVerify} />
    </div>
  );
}
